// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthProvider_wrapper__7zlOU","container":"AuthProvider_container__Y45fT"};